module.exports = __webpack_public_path__ + "img/play.1728a3e7.png";